"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _services = require("../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _brandHifiIcons = require("@vfuk/brand-hifi-icons");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var VerticalExpandingWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var DataEntryWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap;\n  align-items: stretch;\n  justify-content: center;\n"])));
var DataEntryWrapperItem = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n"])));
var LightContainer = (0, _styledComponents.default)((0, _BaseComponents.LightBackground)('div'))(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  text-align: center;\n  flex: 1;\n"])));
var ExpandingWrapper = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var TextDataContainer = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n"])));
var StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  min-height: 70px;\n  &:nth-child(odd) {\n    background-color: #f4f4f4;\n  }\n"])));
var StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  min-height: 0;\n"])));
var StyledSpecGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  align-items: center;\n  justify-content: center;\n  width: 70%;\n"])));
//Label: Category Title
//Data: array of objects containing groups values to be displayed
var ComparisonDataDisplay = function ComparisonDataDisplay(_ref) {
  var label = _ref.label,
    specs = _ref.specs,
    displayedProducts = _ref.displayedProducts;
  var handleBooleanValue = function handleBooleanValue(value) {
    return value === 'true' ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
      name: 'tick',
      group: "system",
      state: "success",
      size: 4
    }) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
      name: 'close',
      group: "system",
      state: "error"
    });
  };
  var valueTextFormatting = function valueTextFormatting(value) {
    return value.text ? value.text === 'true' || value.text === 'false' ? handleBooleanValue(value.text) : value.text : '-';
  };
  var getEntertainmentIcons = function getEntertainmentIcons(value) {
    switch (value) {
      case 'Youtube Premium':
        return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconYoutubePremium, {
          size: 3
        });
      case 'Spotify Premium':
        return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconSpotify, {
          size: 3
        });
      case 'Amazon Prime':
        return /*#__PURE__*/_react.default.createElement(_brandHifiIcons.IconAmazonPrime, {
          size: 3
        });
      default:
        return value;
    }
  };
  var renderEntertainment = function renderEntertainment(value) {
    if (!value.text) return;
    var entertainmentIcons = value.text.split(',');
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(TextDataContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      align: "center"
    }, entertainmentIcons.map(function (iconName, index) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getEntertainmentIcons(iconName), index !== entertainmentIcons.length - 1 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
        spacingLevel: {
          right: 2,
          left: 2
        }
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString("Specs.Or"))));
    })), value.duration && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 1
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 1,
      weight: 2
    }, _services.locale.localeString("Specs.EntertainmentSubtext"), ' ' + value.duration + ' ', _services.locale.localeString("Comparison.Months"))))));
  };
  var renderSpecContent = function renderSpecContent(label, value) {
    switch (label) {
      case 'Colors':
        return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
          spacingLevel: {
            top: 2
          }
        }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSwatch, {
          color: value.colorValue,
          size: 4
        }));
      case 'Entertainment':
        return renderEntertainment(value);
      default:
        return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(TextDataContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
          size: 1,
          weight: 3,
          noMargin: true,
          text: valueTextFormatting(value)
        }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, null, _services.locale.localeString("Specs.".concat(value.subText))))));
    }
  };
  var shouldDisplaySpec = function shouldDisplaySpec(value) {
    return valueTextFormatting(value) !== '-';
  };
  var SpecBoxContent = function SpecBoxContent(_ref2) {
    var spec = _ref2.spec,
      productId = _ref2.productId,
      value = _ref2.value;
    var gridColumnProps = label === 'Colors' && {
      col: 5,
      colMd: 4
    };
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, gridColumnProps, /*#__PURE__*/_react.default.createElement(DataEntryWrapperItem, {
      group: label,
      itemLength: spec.values[productId].length
    }, /*#__PURE__*/_react.default.createElement(ExpandingWrapper, null, renderSpecContent(label, value))));
  };
  var SpecBox = function SpecBox(_ref3) {
    var _spec$values$productI;
    var spec = _ref3.spec,
      index = _ref3.index,
      rowPlacement = _ref3.rowPlacement,
      productId = _ref3.productId;
    return /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
      index: index,
      key: rowPlacement,
      col: 6
    }, /*#__PURE__*/_react.default.createElement(VerticalExpandingWrapper, null, /*#__PURE__*/_react.default.createElement(DataEntryWrapper, {
      groupLabel: label
    }, /*#__PURE__*/_react.default.createElement(StyledSpecGridRow, {
      marginTop: 2,
      marginBottom: 2
    }, (_spec$values$productI = spec.values[productId]) === null || _spec$values$productI === void 0 ? void 0 : _spec$values$productI.map(function (value, valueIndex) {
      return /*#__PURE__*/_react.default.createElement(SpecBoxContent, {
        key: valueIndex,
        spec: spec,
        productId: productId,
        value: value
      });
    })))));
  };
  var GroupSpecs = function GroupSpecs(_ref4) {
    var spec = _ref4.spec,
      index = _ref4.index;
    var shouldDisplayRow = false;
    var result = /*#__PURE__*/_react.default.createElement(StyledGridRow, {
      key: index,
      noGutters: true
    }, displayedProducts === null || displayedProducts === void 0 ? void 0 : displayedProducts.map(function (productId, rowPlacement) {
      var _spec$values$productI2;
      var shouldDisplaySpecification = (_spec$values$productI2 = spec.values[productId]) === null || _spec$values$productI2 === void 0 ? void 0 : _spec$values$productI2.map(function (value) {
        return shouldDisplaySpec(value);
      }).reduce(function (a, b) {
        return a || b;
      });
      shouldDisplayRow = shouldDisplaySpecification || shouldDisplayRow;
      return /*#__PURE__*/_react.default.createElement(SpecBox, {
        spec: spec,
        key: rowPlacement,
        productId: productId
      });
    }));
    return shouldDisplayRow ? result : null;
  };
  var SpecsHeader = function SpecsHeader(_ref5) {
    var specs = _ref5.specs,
      label = _ref5.label;
    var shouldDisplayHeader = displayedProducts.map(function (displayedProduct) {
      return specs.map(function (spec) {
        return spec.values[displayedProduct];
      });
    }).flat(2).filter(function (specValue) {
      return specValue === null || specValue === void 0 ? void 0 : specValue.text;
    }).length;
    return !!shouldDisplayHeader && /*#__PURE__*/_react.default.createElement(LightContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3,
        bottom: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      text: "".concat(_services.locale.localeString("SpecsGroup.".concat(label)))
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SpecsHeader, {
    specs: specs,
    label: label
  }), /*#__PURE__*/_react.default.createElement("div", null, specs === null || specs === void 0 ? void 0 : specs.map(function (spec, index) {
    return /*#__PURE__*/_react.default.createElement(GroupSpecs, {
      spec: spec,
      key: index
    });
  })));
};
var _default = ComparisonDataDisplay;
exports.default = _default;